// PRD §4.1 — auto-numbering helpers. Display numbers are 1-based and derived
// from the tree's array order. Pure functions over the tree shape returned by
// `proItemDesignApi.getTree()`.

import type { ProDomain } from '../types/pro-item-design.types';

// Count all items across the whole tree. Used by the tree header footer
// ("N영역 · N항목").
export function countItems(tree: readonly ProDomain[]): number {
  let n = 0;
  for (const d of tree) for (const s of d.subAreas) n += s.items.length;
  return n;
}

// Build the "N. domain name" / "N-M. sub-area name" / "N-M-L. item name"
// strings used in breadcrumbs and the tree row badges. Indices are 0-based
// inputs that get +1 for display.
export function domainNumber(domainIndex: number): string {
  return String(domainIndex + 1);
}

export function subAreaNumber(domainIndex: number, subAreaIndex: number): string {
  return `${domainIndex + 1}-${subAreaIndex + 1}`;
}

export function itemNumber(
  domainIndex: number,
  subAreaIndex: number,
  itemIndex: number,
): string {
  return `${domainIndex + 1}-${subAreaIndex + 1}-${itemIndex + 1}`;
}
